import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/products/ProductDetail.tsx");
